import { render, staticRenderFns } from "./EditorTiptap.vue?vue&type=template&id=35ff5cd6&"
import script from "./EditorTiptap.vue?vue&type=script&lang=js&"
export * from "./EditorTiptap.vue?vue&type=script&lang=js&"
import style0 from "./EditorTiptap.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports